import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "besidaMob-circleInfo.icon",
  "use": "besidaMob-circleInfo.icon-usage",
  "viewBox": "0 0 513.32 513.32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 513.32 513.32\" id=\"besidaMob-circleInfo.icon\"><path d=\"M235.272 235.272h42.777V384.99h-42.777zM235.272 128.33h42.777v64.165h-42.777z\" /><path d=\"M256.66 0C115.497 0 0 115.497 0 256.66s115.497 256.66 256.66 256.66 256.66-115.497 256.66-256.66S397.823 0 256.66 0zm0 470.543c-117.636 0-213.883-96.247-213.883-213.883S139.024 42.777 256.66 42.777s213.883 96.247 213.883 213.883-96.247 213.883-213.883 213.883z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol